import { Injectable, signal } from '@angular/core';
import { Toast, ToastConfig } from './toast.model';

@Injectable({
  providedIn: 'root',
})
export class MibToastService {
  // Signal holding active toasts
  readonly toasts = signal<Toast[]>([]);

  show(toastConfig: ToastConfig): void {
    const id = new Date().toISOString();
    const duration = typeof toastConfig.duration === 'number' ? toastConfig.duration : 3000;
    const type = toastConfig.type || 'default';
    const toast: Toast = { ...toastConfig, id, duration, type };
    this.toasts.update((current) => [toast, ...current]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  dismiss(id: string): void {
    this.toasts.update((current) => current.filter((t) => t.id !== id));
  }
}
